import { ArrowUpRight } from 'lucide-react';
import { Reveal, Eyebrow } from './Reveal';
import { SERVICES, IMAGES, scrollToId } from '../config/site';

export const Services = () => (
  <section id="services" className="ks-services scroll-mt-24 overflow-hidden py-20 lg:py-28">
    <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
      <Reveal className="mx-auto max-w-3xl text-center">
        <Eyebrow>Our Services</Eyebrow>
        <h2 className="mt-4 text-3xl font-extrabold tracking-tight text-navy sm:text-4xl lg:text-5xl">
          Thoughtful Cleaning for Every Chapter of Home
        </h2>
        <p className="mx-auto mt-5 max-w-2xl text-base leading-relaxed text-charcoal sm:text-lg">
          From everyday care to a fresh start, choose the cleaning service that fits your home
          and your routine.
        </p>
      </Reveal>

      <ul className="mt-12 grid gap-5 sm:grid-cols-2 lg:mt-16 lg:grid-cols-3 lg:gap-7">
        {SERVICES.map((service, index) => (
          <li key={service.id} className="min-w-0">
            <Reveal delay={Math.min(index, 2) * 0.08} className="h-full">
              <div className="ks-service-card group flex h-full flex-col overflow-hidden rounded-[1.65rem] border border-navy/10 bg-white shadow-soft">
                <div className="relative h-48 overflow-hidden sm:h-56">
                  <img
                    src={IMAGES[service.image]}
                    alt={service.alt}
                    loading="lazy"
                    decoding="async"
                    className="h-full w-full object-cover transition-transform duration-500 group-hover:scale-[1.035]"
                  />
                  <span className="absolute left-5 top-5 rounded-full bg-white/95 px-4 py-2 text-xs font-extrabold tracking-widest text-navy shadow-soft">
                    {String(index + 1).padStart(2, '0')} / {String(SERVICES.length).padStart(2, '0')}
                  </span>
                </div>
                <div className="flex flex-1 flex-col px-6 pb-6 pt-6 sm:px-7 sm:pb-7">
                  <h3 className="text-xl font-extrabold tracking-tight text-navy sm:text-2xl">{service.name}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal sm:text-base">{service.description}</p>
                  <button
                    type="button"
                    data-testid={'service-row-' + service.id}
                    onClick={() => scrollToId('quote')}
                    className="mt-6 inline-flex w-fit items-center gap-2 border-b-2 border-fresh pb-1 text-sm font-extrabold text-navy transition-colors hover:border-electric hover:text-electric"
                  >
                    Get a Free Quote
                    <ArrowUpRight size={17} aria-hidden="true" />
                  </button>
                </div>
              </div>
            </Reveal>
          </li>
        ))}
      </ul>

      <Reveal className="mt-12 text-center">
        <p className="text-base font-medium text-navy">Not sure which service fits your home?</p>
        <button
          type="button"
          data-testid="services-quote-button"
          onClick={() => scrollToId('quote')}
          className="mt-5 inline-flex items-center gap-2 rounded-full bg-electric px-9 py-4 text-sm font-bold uppercase tracking-wide text-white shadow-soft transition-colors hover:bg-navy"
        >
          Let's Find the Right Clean
          <ArrowUpRight size={17} aria-hidden="true" />
        </button>
      </Reveal>
    </div>
  </section>
);

export default Services;
